import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import ErrorPage from './ErrorPage';
import { HttpStatusCode } from '../lib/types/HttpStatusCode';

const ErrorPageManager = () => {
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    if (error.status == HttpStatusCode.Status404NotFound) {
      return <ErrorPage title="404 Sidan kunde inte hittas" text="Det finns ingen sida på denna adress." />;
    }
    else if (error.status == HttpStatusCode.Status401Unauthorized) {
      return <ErrorPage title="Autentisering" text="Vi behöver autentisera dig igen." />;
    }
  }
  return <ErrorPage title="Oväntat fel" text="Om felet återkommer så kan du kontakta kundtjänst för hjälp." />;
};

export default ErrorPageManager;
